/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from "@fluentui/react-components";
import { AppTabListOverflowMenuItem } from "./AppTabListOverflowMenuItem";
import type {
  AppTabListOverflowMenuProps,
  AppTabListOverflowMenuSlots,
  AppTabListOverflowMenuState,
} from "./AppTabListOverflowMenu.types";
import { getOverflowPivotHeaderId } from "@1js/acui-pivot";
import { AppTooltipContainer } from "@1js/acui-tooltip";

export const renderAppTabListOverflowMenu = (
  state: AppTabListOverflowMenuState,
  props: AppTabListOverflowMenuProps
) => {
  const { isOverflowing, overflowItems, topItems, onMenuItemClick } = state;
  if (!isOverflowing && overflowItems.length === 0) {
    return null;
  }

  // @ts-ignore -- Remove when https://github.com/microsoft/fluentui/issues/29578 is fixed
  assertSlots<AppTabListOverflowMenuSlots>(state);

  return (
    <AppTooltipContainer {...props} label="">
      <state.root>
        <state.menuTrigger>
          <state.trigger />
        </state.menuTrigger>
        <state.menuPopover>
          <state.menuList>
            <state.menuListWrapper>
              {isOverflowing &&
                topItems.map((header) => (
                  <AppTabListOverflowMenuItem
                    id={getOverflowPivotHeaderId(header.id)}
                    key={header.id}
                    header={header}
                    onClick={(
                      event:
                        | React.MouseEvent<HTMLDivElement, MouseEvent>
                        | React.KeyboardEvent<HTMLDivElement>
                    ) => onMenuItemClick(event, header.id)}
                  />
                ))}
              {overflowItems.map((header) => (
                <AppTabListOverflowMenuItem
                  id={getOverflowPivotHeaderId(header.id)}
                  key={header.id}
                  header={header}
                  ignoreIsOverflowItemVisible={true}
                  onClick={(
                    event:
                      | React.MouseEvent<HTMLDivElement, MouseEvent>
                      | React.KeyboardEvent<HTMLDivElement>
                  ) => onMenuItemClick(event, header.id)}
                />
              ))}
            </state.menuListWrapper>
          </state.menuList>
        </state.menuPopover>
      </state.root>
    </AppTooltipContainer>
  );
};
